/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const PromptTypeEnum = core.serialization.enum_(["AI_ASSIST", "CONSTRAINT_GENERATION"]);
